<!-- 就是SvgIcon -->
<template>
  <svg aria-hidden="true" class="easy-icon" @click="handleClick">
    <use :href="symbolId" :fill="fill" />
  </svg>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    name: string;
    prefix?: string;
    fill?: string;
  }>(),
  { prefix: 'icon', fill: undefined }
);

const emit = defineEmits({
  click: (evt: MouseEvent) => evt instanceof MouseEvent
});

const symbolId = computed(() => `#${props.prefix}-${props.name}`);

const handleClick = (event: MouseEvent) => {
  emit('click', event);
};
</script>

<style lang="scss" scoped>
.easy-icon {
  width: 1em;
  height: 1em;
}

.easy-icon:focus {
  outline: none;
}
</style>
